export default "__VITE_ASSET__CzVbzUfC__"